import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i192332994__a)" }, [
      _createElementVNode("path", {
        fill: "#1E1E1E",
        stroke: "#1E1E1E",
        d: "M17.39 16.864c.013 0 .021.002.027.004a.06.06 0 0 1 .018.014l6.047 6.047a.063.063 0 0 1 0 .09l-.463.463a.063.063 0 0 1-.09 0l-6.04-6.039c-.02-.022-.025-.04-.025-.052v-.527h.527ZM9.75.5C14.86.5 19 4.64 19 9.75a9.207 9.207 0 0 1-2.459 6.274l-.283.305-.233.216A9.249 9.249 0 0 1 .5 9.75C.5 4.64 4.64.5 9.75.5Zm0 .5A8.744 8.744 0 0 0 1 9.75a8.744 8.744 0 0 0 8.75 8.75 8.744 8.744 0 0 0 8.75-8.75A8.744 8.744 0 0 0 9.75 1Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i192332994__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }